import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RichTextService {

  constructor() { }
  getHtml(text:string) {
    try {
      text = text.replace(/<br>/gi, '<br/>');
      var doc = new DOMParser().parseFromString(text, "text/html");
      var tags = doc.querySelectorAll('p, ul, ol');
      for (var i = 0, len = tags.length; i < len; i++) {
        if ((tags[i].className || tags[i].className === "") && tags[i].className.indexOf('ql-align') === -1) {
          tags[i].classList.add("ql-align-left");
        }
      }
      return doc.body.innerHTML;
    } catch (e) {
      return text;
    }
  }
}
